import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/rent/')({
	beforeLoad: () => {
		throw redirect({ to: '/rent/active' })
	},
})
